export default __webpack_public_path__ + "static/media/mushroom-sweet-potato.a55b79be.jpeg";